import React, { useState, useEffect } from 'react'
import { Ajax } from '../common'
import { makeApiRequest } from '../common'
import arcmIcons from '../Icons'
import Modal from '../components/core/Modal'

const ArchivedOrder = () => {
  const [orders, setOrders] = useState([])

  const [selectAll, setSelectAll] = useState(false)
  const [bulkAction, setBulkAction] = useState('') // Track bulk action
  const [currentPage, setCurrentPage] = useState(1)
  const [totaOrderNumber, setTotaOrderNumber] = useState(0)
  const [modalLoading, setmodalLoading] = useState(false)
  const [isOpenUnarchiveModal, setIsOpenUnarchiveModal] = useState(false)
  const [modalTile, setmodalTile] = useState('Unarchiving Order')
  const [modaDesc, setmodaDesc] = useState('')
  const ordersPerPage = 10

  // Calculate pagination details
  const totalPages = Math.ceil(parseInt(totaOrderNumber) / ordersPerPage)
  const startIndex = (currentPage - 1) * ordersPerPage

  // Toggle select all orders
  const handleSelectAll = () => {
    const newSelectAll = !selectAll
    setSelectAll(newSelectAll)
    setOrders(orders.map(order => ({ ...order, is_selected: newSelectAll })))
  }

  // Toggle select individual order
  const handleSelectOrder = id => {
    const updatedOrders = orders.map(order =>
      order.id === id ? { ...order, is_selected: !order.is_selected } : order
    )
    setOrders(updatedOrders)
    setSelectAll(updatedOrders.every(order => order.isSelected)) // If all orders are selected
  }

  // Get Selected Order
  const getSelectedOrder = () => {
    const selectedOrder = orders.filter(order => order.is_selected)
    return selectedOrder
  }

  // delete order from remote database
  const deleteOrder = async orders => {
    let orderIds = []
    orders.map(order => {
      orderIds.push(order.id)
    })
    setmodalTile('Unarchiving order complete')
    setmodaDesc('Deleting Unarchived order from RDS')
    // const deleteRemoteOrders = await Ajax.post(
    //   `archm_delete_unarchived_order`,
    //   orderIds
    // )
    const deleteRemoteOrders = await makeApiRequest(
      'delete-unarchived-orders',
      'POST',
      orderIds
    )
    if (deleteRemoteOrders.success) {
      setmodalTile('Successfulley Order Unarchived')
      setmodaDesc('')
      setmodalLoading(false)
      location.reload()
    }
  }

  // Handle unarchiving single order
  const unarchiveOrder = async orders => {
    setmodalLoading(true)
    handleUnarchiveModal()
    //const unarchiveOrders = await Ajax.post(`archm_unarchived_order`, orders)
    const unarchiveOrders = await makeApiRequest(
      'unarchive-orders',
      'POST',
      orders
    )
    if (unarchiveOrders.success) {
      deleteOrder(orders)
    } else {
      setmodalTile('Modal Loading Failed')
    }
  }

  // single order unarchive
  const singelOrderUnarchive = orderId => {
    const order = orders.filter(order => order.id === orderId)
    unarchiveOrder(order)
  }

  // Handle bulk actions (unarchive selected orders)
  const handleBulkAction = () => {
    if (bulkAction === 'unarchive') {
      const selectedOrders = getSelectedOrder()
      if (selectedOrders.length == 0) {
        alert('please select order')
        return
      }
      unarchiveOrder(selectedOrders)
    } else {
      alert('No bulk action selected')
    }
  }

  // get archived order form server
  const getArchivedOrder = async () => {
    // const archivedDtata = await Ajax.post(`archm_get_archived_order`, {
    //   ordersPerPage,
    //   startIndex
    // })
    const archivedDtata = await makeApiRequest(`archived-orders`, 'POST', {
      ordersPerPage,
      startIndex
    })
    console.log(archivedDtata)
    if (archivedDtata.success) {
      const { orders, total_order } = archivedDtata.data
      setOrders(orders)
      setTotaOrderNumber(total_order)
    } else {
      setOrders([])
    }
  }

  // Handle pagination
  const handlePageChange = page => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page)
    }
  }

  // hadlde close open unarchiving modal
  const handleUnarchiveModal = () => {
    setIsOpenUnarchiveModal(!isOpenUnarchiveModal)
  }

  useEffect(() => {
    getArchivedOrder()
  }, [currentPage])

  return (
    <>
      <div className='table-container'>
        {/* Bulk action select dropdown */}
        <div className='bulk-action-container'>
          <select
            value={bulkAction}
            onChange={e => setBulkAction(e.target.value)}
          >
            <option value=''>Bulk actions</option>
            <option value='unarchive'>Unarchive orders</option>
          </select>
          <button onClick={handleBulkAction}>Apply</button>
        </div>

        <table>
          <thead>
            <tr>
              <th>
                <input
                  type='checkbox'
                  checked={selectAll}
                  onChange={handleSelectAll}
                />
              </th>
              <th>Order</th>
              <th>Date</th>
              <th>Status</th>
              <th>Total</th>
              <th>Archive Action</th>
            </tr>
          </thead>
          <tbody>
            {orders.length > 0
              ? orders.map(order => (
                  <tr key={order.id} id={order.id}>
                    <td>
                      <input
                        type='checkbox'
                        checked={order.is_selected}
                        onChange={() => handleSelectOrder(order.id)}
                      />
                    </td>
                    <td>#{order.archived_order_id}</td>
                    <td>{order.date}</td>
                    <td>{JSON.parse(order.order_data).status}</td>
                    <td>{JSON.parse(order.order_data).total}</td>
                    <td>
                      <button
                        onClick={() => singelOrderUnarchive(order.id)}
                        className='unarchive-button'
                      >
                        Unarchive
                      </button>
                    </td>
                  </tr>
                ))
              : 'No archived data found'}
          </tbody>
        </table>
        {/* Pagination Controls */}
        <div className='pagination'>
          <button
            onClick={() => handlePageChange(currentPage - 1)}
            disabled={currentPage === 1}
          >
            Previous
          </button>
          <span>
            Page {currentPage} of {totalPages}
          </span>
          <button
            onClick={() => handlePageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
          >
            Next
          </button>
        </div>
      </div>
      <Modal
        openModal={isOpenUnarchiveModal}
        toggleModal={handleUnarchiveModal}
        outerClick={false}
      >
        {{
          body: modalLoading ? (
            <div className='arcm-text-center arcm-mb-6'>
              <div className='icon arcm-inline-flex'>
                {arcmIcons.SpinningAnimation}
              </div>
              <h5 className='arcm-text-gray-900 arcm-text-base arcm-font-semibold arcm-mb-1.5'>
                {modalTile}
              </h5>
              <p className='arcm-text-center arcm-text-gray-900 arcm-text-sm arcm-font-normal arcm-mb-6'>
                {modaDesc}
              </p>
            </div>
          ) : (
            <div className='arcm-text-center arcm-my-6'>
              <div className='icon arcm-inline-flex arcm-mb-6'>
                <svg
                  xmlns='http://www.w3.org/2000/svg'
                  width='60'
                  height='60'
                  viewBox='0 0 60 60'
                  fill='none'
                >
                  <path
                    d='M30 60C46.5685 60 60 46.5685 60 30C60 13.4315 46.5685 0 30 0C13.4315 0 0 13.4315 0 30C0 46.5685 13.4315 60 30 60Z'
                    fill='#27D935'
                  />
                  <path
                    d='M30 60C46.5685 60 60 46.5685 60 30C60 13.4315 46.5685 0 30 0C13.4315 0 0 13.4315 0 30C0 46.5685 13.4315 60 30 60Z'
                    fill='#27D935'
                  />
                  <path
                    fill-rule='evenodd'
                    clip-rule='evenodd'
                    d='M14.5801 31.414L24.5801 41.414C25.3601 42.196 26.6281 42.196 27.4081 41.414L45.4081 23.414C46.1881 22.634 46.1881 21.366 45.4081 20.586C44.6281 19.806 43.3601 19.806 42.5801 20.586L25.9941 37.172L17.4081 28.586C16.6281 27.806 15.3601 27.806 14.5801 28.586C13.8001 29.366 13.8001 30.634 14.5801 31.414Z'
                    fill='white'
                  />
                </svg>
              </div>
              <h5 className='arcm-text-gray-900 arcm-text-base arcm-font-semibold arcm-mb-1.5'>
                {modalTile}
              </h5>
              <button
                onClick={handleUnarchiveModal}
                className='arcm-text-white arcm-text-sm arcm-font-semibold arcm-px-4 arcm-py-3 arcm-min-w-[120px] arcm-bg-[#3858e9] arcm-rounded-lg arcm-justify-center arcm-items-center arcm-gap-2 arcm-inline-flex arcm-transition-all hover:arcm-bg-blue-700'
              >
                <span>Ok</span>
              </button>
            </div>
          )
        }}
      </Modal>
    </>
  )
}

export default ArchivedOrder
